/* import axios from 'axios' */
import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterContratos(ehFornecedor) {
        if (ehFornecedor) {
            return axiosJwt
                .get(`${api}/fornecedor/contratos/distribuidos`)
                .then(response => {
                    return response.data
                })
                .catch(error => {
                    return errorHandler(error)
                })
        } else {
            return axiosJwt
                .get(`${api}/fornecedor/contratos/vinculados-usuario/distribuidos`)
                .then(response => {
                    return response.data
                })
                .catch(error => {
                    return errorHandler(error)
                })
        }
    },

    obterItens(contratoId) {
        return axiosJwt
            .get(`${api}/fornecedor/contratos/${contratoId}/itens`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterHistoricoAditivos(contratoId) {
        return axiosJwt
            .get(`${api}/fornecedor/contratos/${contratoId}/historico-aditivos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterRequisicoes(codContrato) {
        let url = `${api}/fornecedor/contratos/${codContrato}/requisicoes`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterRequisicao(codContrato, idRequisicao) {
        let url = `${api}/fornecedor/contratos/${codContrato}/requisicoes/${idRequisicao}`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoAnexos(fornecedorId, codContrato, idComprometimento) {
        let url = `${api}/fornecedor/contratos/${codContrato}/comprometimentos/${idComprometimento}/anexos`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoAnexosTipos(codContrato) {
        let url = `${api}/fornecedor/contratos/${codContrato}/comprometimentos/anexos/tipos`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirComprometimentoAnexo(codContrato, anexo) {
        const formData = new FormData()
        formData.append('idComprometimento', anexo.idComprometimento)
        formData.append('tipoId', anexo.tipoId)
        formData.append('descritivo', anexo.descritivo)
        formData.append('arquivo', anexo.arquivo)

        return axiosJwt
            .post(
                `${api}/fornecedor/contratos/${codContrato}/comprometimentos/${anexo.idComprometimento}/anexos/`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoAnexo(
        codContrato,
        idComprometimento,
        comprometimentoAnexoId
    ) {
        return axiosJwt
            .get(
                `${api}/fornecedor/contratos/${codContrato}/comprometimentos/${idComprometimento}/anexos/${comprometimentoAnexoId}`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirComprometimentoAnexo(
        codContrato,
        idComprometimento,
        comprometimentoAnexoId
    ) {
        let url = `${api}/fornecedor/contratos/${codContrato}/comprometimentos/${idComprometimento}/anexos/${comprometimentoAnexoId}`
        return axiosJwt
            .delete(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    enviarComprometimentoParaAnalise(codContrato, idComprometimento) {
        let url = `${api}/fornecedor/contratos/${codContrato}/comprometimentos/${idComprometimento}/enviaranalise`
        return axiosJwt
            .patch(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    cancelarEnvioComprometimentoParaAnalise(codContrato, idComprometimento) {
        let url = `${api}/fornecedor/contratos/${codContrato}/comprometimentos/${idComprometimento}/cancelarenvioanalise`
        return axiosJwt
            .patch(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoAprovadores(codContrato, idComprometimento) {
        let url = `${api}/fornecedor/contratos/${codContrato}/comprometimentos/${idComprometimento}/aprovadores`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentos(codContrato) {
        let url = `${api}/fornecedor/contratos/${codContrato}/comprometimentos`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTimeLine(codContrato, idComprometimento) {
        let url = `${api}/fornecedor/contratos/${codContrato}/comprometimentos/${idComprometimento}/timeline`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterFaseDemandaAtual(contratoId) {
        let url = `${api}/fornecedor/contratos/${contratoId}/fases/demanda-atual`

        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAbasBoletinsMedicao() {
        let url = `${api}/fornecedor/contratos/abas-boletins-medicao`

        return axiosJwt
            .get(url)
            .then(response => {
                return response
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterConfiguracaoAbasBoletinsMedicao(codContrato) {
        let url = `${api}/fornecedor/contratos/${codContrato}/configuracao-abas-boletins-medicao`

        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarConfiguracaoAbasBoletinsMedicao(codContrato, dto) {
        let url = `${api}/fornecedor/contratos/${codContrato}/configuracao-abas-boletins-medicao`

        return axiosJwt
            .put(url, dto)
            .then(response => {
                return response
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterItensPai(contratoId) {
        return axiosJwt
            .get(`${api}/fornecedor/contratos/${contratoId}/itens`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    uploadCronogramaFisicoFinanceiro(contratoId, boletimMedicaoId, uploadDto) {
        return axiosJwt
            .post(`${api}/fornecedor/contratos/${contratoId}/boletins-medicao/${boletimMedicaoId}/upload-cronograma-fisico-financeiro-arquivo`, uploadDto)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    async uploadArquivo(uploadDto) {
        try {
            const response = await axiosJwt.post(`${api}/fornecedor/contratos/upload-arquivo`, uploadDto)
            return response.data
        } catch (error) {
            if (error.response && error.response.data instanceof Blob) {
                const text = await error.response.data.text()
                try {
                    const jsonError = JSON.parse(text)
                    error.response.data = jsonError
                } catch (e) {
                    error.response.data = { message: text }
                }
            }
            throw error
        }
    },
}
